import React, { FC } from 'react';
import styled from 'styled-components';
import { Collector } from '../../models/Collector';
import { COLORS } from '../../utils/Colors';

type LevelType = 'PET' | 'ALU' | 'GLS';

const Root = styled.div`
    display: flex;
    flex-direction: row;
    background: ${COLORS.WHITE};
    border: none;
    border-radius: 8px;
    padding: 10px;
    min-width: 120px;
    flex: 1;
    
    @media screen and (max-width: 768px) {
        min-width: 100px;
        padding: 8px;
        border: 1px solid #e0e0e0;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }
    
    @media screen and (max-width: 480px) {
        min-width: 80px;
        padding: 6px;
        border: 1px solid #e0e0e0;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }
`;

const BarContainer = styled.div`
    border: none;
    border-radius: 12px;
    background: ${COLORS.DULL};
    display: flex;
    align-items: flex-end;
    height: 100px;
    width: 50px;
    
    @media screen and (max-width: 768px) {
        height: 80px;
        width: 40px;
    }
    
    @media screen and (max-width: 480px) {
        height: 60px;
        width: 30px;
    }
`;

const Bar = styled.div`
    height: 85%;
    width: 100%;
    border-radius: 12px;
    background: ${COLORS.GREEN};
    margin-bottom: 2px;
`;

const TextContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-left: 16px;
    
    @media screen and (max-width: 768px) {
        margin-left: 12px;
    }
    
    @media screen and (max-width: 480px) {
        margin-left: 8px;
    }
`;

const Level = styled.span`
    font-size: 22px;
    font-weight: bold;
    color: ${COLORS.DARK_GRAY};
    
    @media screen and (max-width: 768px) {
        font-size: 18px;
    }
    
    @media screen and (max-width: 480px) {
        font-size: 16px;
    }
`;

const Material = styled.span`
    font-size: 12px;
    color: ${COLORS.DARK_GRAY};
    
    @media screen and (max-width: 768px) {
        font-size: 11px;
    }
    
    @media screen and (max-width: 480px) {
        font-size: 10px;
    }
`;

const TypeName: Record<LevelType, string> = {
  PET: 'Plastic',
  ALU: 'Aluminum',
  GLS: 'Glass',
};

interface Props {
  collector: Collector;
  type: LevelType;
}

export const FillLevelWidget: FC<Props> = ({ collector, type }) => {
  // @ts-ignore
  const level: number = collector.bin_levels[`${type.toLowerCase()}_bin_level_pct`];
  const barHeight = Math.max(0, Math.min(100, level));
  const barColor = level < 80 ? COLORS.BLUE : COLORS.RED;
  
  // Ajustar la altura de la barra para que no se vea pegada cuando está al 100%
  const adjustedBarHeight = barHeight === 100 ? 95 : (barHeight < 10 ? 10 : barHeight);
  
  return (
    <Root>
      <BarContainer>
        <Bar style={{ height: `${adjustedBarHeight}%`, backgroundColor: barColor }} />
      </BarContainer>
      <TextContainer>
        <Level>{level > 100 ? 100 : level}%</Level>
        <Material>{TypeName[type]}</Material>
      </TextContainer>
    </Root>
  );
};
